import { useEffect, useState } from "react";
import api from "../lib/api";

const FALLBACK = {
  hero: {
    eyebrow: "UK-Wide Accredited K9 Security",
    line1: "Detection Dogs",
    line2: "That Mean Business",
    subtitle: "Explosives, narcotics and knife detection teams for events, schools, venues and businesses.",
  },
  contact: {
    phone: "07898 234977",
    email: "hello@questk9.co.uk",
    website: "www.questk9.co.uk",
    coverage: "UK-Wide",
    hours: "24/7 rapid response",
  },
  about: {
    title: "Excellence in Canine Security",
    story: [],
    image: "",
  },
  chrome: {
    nav_request_button: "Request a Sweep",
    nav_labels: {},
    hero_primary: "Request a Free Consultation",
    hero_secondary: "Meet the Dogs",
    cta_message_label: "Send Us a Message",
  },
  pages: {
    logo_title: "QUEST K9's",
    logo_subtitle: "DETECTION DOGS",
    footer_text: "Accredited sniffer dog and knife detection teams. Protecting venues, schools and events across the UK.",
    home_badges: "Accredited Handlers | 24/7 Rapid Response | UK-Wide Coverage",
    dogs: {
      eyebrow: "The Team",
      title: "Meet Our",
      title_accent: "Canine Specialists",
      intro: "Every dog at Quest K9's is raised and trained in-house, socialised from puppyhood, and paired with one accredited handler for their whole career.",
      empty: "No dogs listed yet - check back soon.",
    },
    sale: {
      eyebrow: "Dogs For Sale",
      title: "Working dogs,",
      title_accent: "ready for new homes",
      intro: "Occasionally we have fully trained dogs and puppies from our own breeding lines available to approved, experienced homes. Every dog is health-checked, vaccinated and microchipped. Message us for full details and pricing.",
      empty: "No dogs for sale right now - check back soon, or message us about upcoming litters.",
      card_button: "Message for Details",
      rehome_title: "Can't house your dog anymore?",
      rehome_accent: "We'll take it.",
      rehome_text: "Life changes, and sometimes a much-loved dog can no longer stay with you. If you're struggling to house your dog, message us - we'll assess them, bring on any training they need, and give them a working home with people who understand the breed. No judgement, just a safe landing.",
      rehome_button: "Ask Us to Take Your Dog",
    },
    contact: {
      eyebrow: "Contact Us",
      title: "Deploy",
      title_accent: "Quest K9 Teams",
      intro: "Tell us about your venue, dates and concerns. We reply fast - and urgent requests jump the queue.",
      f_name: "Full Name *",
      f_email: "Email *",
      f_phone: "Phone",
      f_date: "Date Needed",
      f_time: "Time Needed",
      f_location: "Location",
      f_service: "Service Required",
      f_service_ph: "Choose a service",
      f_message: "Your Message *",
      urgent_label: "This is urgent / same-day",
      submit: "Send Message",
      sending: "Sending...",
    },
    about_page: {
      eyebrow: "About Us",
      values_eyebrow: "What We Stand For",
      values_title: "Values that walk the walk",
      acc_eyebrow: "Accreditation & Compliance",
      acc_title: "Fully credentialed. Fully insured.",
    },
    blog: {
      eyebrow: "The Journal",
      title: "News from the",
      title_accent: "kennels",
      intro: "Updates, deployment notes and behind-the-scenes stories from Quest K9's Detection Dogs.",
      empty: "No posts yet - check back soon.",
    },
  },
};

export const useSiteContent = () => {
  const [content, setContent] = useState(FALLBACK);
  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent(r.data))
      .catch(() => setContent(FALLBACK));
  }, []);
  return content;
};
